import { SidecarDetailRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const sidecarDetailQueryAtom = createQueryAtomFactory(
  'settings.sidecarDetail',
  (params: { ids: string[] }) => ({
    sidecars: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        operatingSystem: true,
        operatingSystemVersion: true,
        version: true,
        localIpAddress: true,
        remoteIpAddressV4: true,
        remoteIpAddressV6: true,
        linkSpeedUpstream: true,
        linkSpeedDownstream: true,
        latencyMs: true,
        jitterMs: true,
        peerId: true,
        multiaddrs: true,
        publicKey: true,
        status: true,
        online: true,
        lastHeartbeatAt: true,
        connectedAt: true,
        facilityId: true,
        settings: {
          discoveryEnabled: true,
        },
        facility: {
          id: true,
          facilityName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): SidecarDetailRecord | null => {
      const entry = data?.sidecars?.entries?.[0];
      if (!entry) {
        return null;
      }

      return {
        id: entry.id,
        name: entry.name,
        operatingSystem: entry.operatingSystem,
        operatingSystemVersion: entry.operatingSystemVersion,
        version: entry.version ?? null,
        localIpAddress: entry.localIpAddress ?? null,
        remoteIpAddressV4: entry.remoteIpAddressV4 ?? null,
        remoteIpAddressV6: entry.remoteIpAddressV6 ?? null,
        linkSpeedUpstream: entry.linkSpeedUpstream ?? null,
        linkSpeedDownstream: entry.linkSpeedDownstream ?? null,
        latencyMs: (entry.latencyMs as number) ?? null,
        jitterMs: (entry.jitterMs as number) ?? null,
        peerId: entry.peerId ?? null,
        multiaddrs: (entry.multiaddrs as string[]) ?? [],
        publicKey: entry.publicKey ?? null,
        status: entry.status as SidecarDetailRecord['status'],
        online: entry.online ?? false,
        lastHeartbeatAt: entry.lastHeartbeatAt
          ? parseZonedDateTime(entry.lastHeartbeatAt)
          : null,
        connectedAt: entry.connectedAt
          ? parseZonedDateTime(entry.connectedAt)
          : null,
        settings: {
          discoveryEnabled: entry.settings?.discoveryEnabled ?? true,
        },
        facilityId: entry.facilityId,
        facility: entry.facility
          ? {
              id: entry.facility.id,
              name: entry.facility.facilityName,
            }
          : null,
        timestamps: {
          createdAt: parseZonedDateTime(entry.timestamps.createdAt),
          updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
        },
      };
    },
  },
);
